export var componentsLocales = {
  addButtonComment: 'Нажмите запятую или пробел',
  addButtonTitle: 'Добавить'
};